:host {
  /**
   * @prop --c-pagination-button-active-background-color: Active pagination button background color
   * @prop --c-pagination-button-active-background-color-hover: Active pagination button hover background color
   * @prop --c-pagination-button-active-text-color: Active pagination button text color
   * @prop --c-pagination-button-background-color: Pagination button background color
   * @prop --c-pagination-button-background-color-hover:  Pagination button hover background color
   * @prop --c-pagination-button-text-color: Pagination button text color
   * @prop --c-pagination-text-color: Pagination text color
   */
  --_c-pagination-button-active-background-color: var(--c-pagination-button-active-background-color, var(--c-primary-600));
  --_c-pagination-button-active-background-color-hover: var(--c-pagination-button-active-background-color-hover, var(--c-primary-400));
  --_c-pagination-button-active-text-color: var(--c-pagination-button-active-text-color, var(--c-white));
  --_c-pagination-button-background-color: var(--c-pagination-button-background-color, var(--c-transparent));
  --_c-pagination-button-background-color-hover: var(--c-pagination-button-background-color-hover, rgba(var(--c-primary-rgb), 0.1));
  --_c-pagination-button-text-color: var(--c-pagination-button-text-color, var(--_c-pagination-button-active-background-color));
  --_c-pagination-text-color: var(--c-pagination-text-color, var(--c-text-system));

  /**
   * @prop --c-pagination-menu-text-color: Pagination menu text color
   * @prop --c-pagination-menu-text-color-active: Active pagination menu text color
   * @prop --c-pagination-menu-background-color-hover: Pagination menu hover background color
   * @prop --c-pagination-menu-outline-color: Pagination menu outline color
   */
  --_c-pagination-menu-text-color: var(--c-pagination-menu-text-color, var(--c-text-system));
  --_c-pagination-menu-text-color-active: var(--c-pagination-menu-text-color-active, var(--c-primary-600));
  --_c-pagination-menu-background-color-hover: var(--c-pagination-menu-background-color-hover, var(--c-primary-200));
  --_c-pagination-menu-outline-color: var(--c-pagination-menu-outline-color, var(--c-primary-600));

  c-icon-button {
    --c-icon-button-background-color: var(--_c-pagination-button-active-background-color);
    --c-icon-button-background-color-hover: var(--_c-pagination-button-active-background-color-hover);
    --c-icon-button-text-color: var(--_c-pagination-button-active-text-color);
    --c-icon-button-text-background-color: var(--_c-pagination-button-background-color);
    --c-icon-button-text-background-color-hover: var(--_c-pagination-button-background-color-hover);
    --c-icon-button-text-text-color: var(--_c-pagination-button-text-color);
  }

  display: block;

  span {
    font-size: 14px;
    text-align: right;
    white-space: nowrap;
  }

  .range {
    min-width: 132px;
  }

  .visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}

:host(.c-pagination) {
  nav {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0 24px;
    justify-content: center;
    width: 100%;
  }

  ul {
    align-items: center;
    display: flex;
    gap: 4px;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .c-pagination__details {
    color: var(--_c-pagination-text-color);
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    flex: auto;
    justify-content: space-between;
  }

  .c-pagination__items-per-page {
    color: var(--_c-pagination-text-color);
    font-size: 14px;
    text-align: right;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  c-menu {
    --c-menu-text-color: var(--_c-pagination-menu-text-color);
    --c-menu-text-color-active: var(--_c-pagination-menu-text-color-active);
    --c-menu-background-color-hover: var(--_c-pagination-menu-background-color-hover);
    --c-menu-outline-color: var(--_c-pagination-menu-outline-color);
  }
}

:host(.c-pagination--simple) {
  ul {
    flex: 1;
    justify-content: flex-end;
  }
}

:host(.c-pagination--small) {
  ul {
    gap: 2px;
  }
}
